
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/quickstart",
      function () {
        return require("private-next-pages/docs/quickstart.md");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/quickstart"])
      });
    }
  